"use strict";

import angular from "angular";

import { Validations } from "../../imports/validations";

const name = "hasFeatureFlag";
const factory = [
    "$timeout",
    ($timeout) => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const method = $attr.hasFeatureFlag;
            const loadPermission = () => {
                if (!Validations.hasFeatureFlag(method)) $elem.remove();
            };
            loadPermission();
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
